import { motion } from "framer-motion";
import { fadeUp } from "./motion";
import { ASSETS } from "../../data/site";

const CHAPTERS = [
  { no: "01", title: "One Dream, One Truck", text: "Rock N Roll Ice Cream started with a single mobile dessert truck and one obsession — rolled ice cream, made fresh, made right." },
  { no: "02", title: "Six Locations Strong", text: "That one truck grew into a California favorite — six shops across Lathrop, Manteca, Stockton, Modesto, Lodi & Merced." },
  { no: "03", title: "Made To Order, Always", text: "Every order is rolled fresh right in front of you on a frozen pan — a dessert as entertaining as it is delicious." },
];

export const Story = () => {
  return (
    <section id="story" data-testid="story-section" className="relative bg-[#FFE9F1]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20 sm:py-28">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-5">
            <motion.span variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }}
              className="eyebrow text-[#12B99B]">Our Story</motion.span>
            <motion.h2 variants={fadeUp} custom={1} initial="hidden" whileInView="show" viewport={{ once: true }}
              className="font-display mt-4 text-[clamp(2rem,5vw,3.75rem)] leading-[1.02] text-[#2A1620]">
              From a truck to a <span className="font-script text-[#F63C8B]">movement</span>
            </motion.h2>
            <motion.div variants={fadeUp} custom={2} initial="hidden" whileInView="show" viewport={{ once: true }}
              className="mt-8 relative">
              <img src={ASSETS.truck} alt="The original Rock N Roll hand-rolled ice cream truck"
                className="w-full aspect-[4/3] object-cover rounded-[2rem] border-4 border-white shadow-[0_30px_60px_-28px_rgba(246,60,139,0.5)]" />
              <span className="absolute bottom-3 left-3 bg-white/90 backdrop-blur px-3 py-1.5 rounded-full text-[11px] font-bold uppercase tracking-[0.15em] text-[#F63C8B]">
                Where it all began
              </span>
              <img src={ASSETS.logoRed} alt="" aria-hidden="true"
                className="absolute -top-6 -right-4 h-24 w-24 object-contain animate-spin-slow bg-white rounded-full p-1.5 border-4 border-white shadow-lg" />
            </motion.div>
          </div>

          <div className="lg:col-span-7">
            {CHAPTERS.map((c, i) => (
              <motion.div key={c.no} variants={fadeUp} custom={i} initial="hidden" whileInView="show" viewport={{ once: true }}
                data-testid={`story-chapter-${c.no}`}
                className="group flex gap-5 sm:gap-8 py-6 border-b border-[#F4C9DC] first:border-t">
                <span className="font-display text-3xl sm:text-4xl text-[#F9A8CB] group-hover:text-[#F63C8B] transition-colors">{c.no}</span>
                <div>
                  <h3 className="font-display text-xl sm:text-2xl text-[#2A1620]">{c.title}</h3>
                  <p className="mt-2 text-[#6E5A64] leading-relaxed max-w-xl">{c.text}</p>
                </div>
              </motion.div>
            ))}
            <motion.p variants={fadeUp} custom={3} initial="hidden" whileInView="show" viewport={{ once: true }}
              className="mt-7 text-lg text-[#3A2A32] leading-relaxed max-w-xl">
              Our mission never changed: <span className="text-[#F63C8B] font-semibold">premium handcrafted rolled ice cream, made fresh to order</span> — and an unforgettable experience for every customer.
            </motion.p>
          </div>
        </div>
      </div>
    </section>
  );
};
